import { ChecklistTemplateRepository } from "../../repositories/ChecklistTemplateRepository";
import { ChecklistTemplateItemEntity } from "../../entities/ChecklistTemplateEntity";

/**
 * Get Template Items Grouped Use Case
 * Retrieves all items for a template grouped by accounting area
 */
export class GetTemplateItemsGroupedUseCase {
  constructor(private repository: ChecklistTemplateRepository) {}

  async execute(
    templateId: number
  ): Promise<Record<string, ChecklistTemplateItemEntity[]>> {
    return await this.repository.getTemplateItemsGrouped(templateId);
  }
}

